export type PwaRuntimeContext = "pwa" | "web";

export const getRuntimeContext = (): PwaRuntimeContext => {
  if (typeof window === "undefined") return "web";
  const isStandalone =
    window.matchMedia?.("(display-mode: standalone)").matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return isStandalone ? "pwa" : "web";
};
